import { render } from "./TrustFooterSection.vue?vue&type=template&id=45bd40f0&scoped=true"
const script = {}

import "./TrustFooterSection.vue?vue&type=style&index=0&id=45bd40f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bd40f0"]])

export default __exports__